/**
 * V1-space phone branch helpers (gotoScene fields).
 * Used only by the v1→v2 migration tooling (inline-choice-model, migrate-scenario-converge).
 */

import type { V1PhoneChatReplyOption } from './legacy-v1-types';

export function collectPhoneReplyGotoScenes(options: V1PhoneChatReplyOption[]): string[] {
  const scenes: string[] = [];
  for (const opt of options) {
    if (opt.gotoScene) scenes.push(opt.gotoScene);
    if (opt.replyOptions?.length) {
      scenes.push(...collectPhoneReplyGotoScenes(opt.replyOptions));
    }
  }
  return scenes;
}

/** Feuilles avec réplique contact et sans sous-choix → gotoScene de convergence. */
export function applyAutoConvergeToPhoneReplies(
  options: V1PhoneChatReplyOption[],
  convergeSceneId: string
): V1PhoneChatReplyOption[] {
  return options.map((opt) => {
    const nested = opt.replyOptions?.length
      ? applyAutoConvergeToPhoneReplies(opt.replyOptions, convergeSceneId)
      : undefined;
    const hasNested = (nested?.length ?? 0) > 0;
    const hasContactReply = Boolean(opt.contactReply?.trim());

    let gotoScene = opt.gotoScene;
    if (hasNested) {
      gotoScene = undefined;
    } else if (hasContactReply) {
      gotoScene = convergeSceneId;
    } else if (gotoScene === convergeSceneId) {
      gotoScene = undefined;
    }

    return {
      ...opt,
      gotoScene,
      ...(hasNested || hasContactReply ? { gotoBlockId: undefined } : {}),
      replyOptions: nested,
    };
  });
}
